import { useSyncExternalStore } from "react";

const listeners = new Set();
let listening = false;
let frameId = 0;
let previousY = 0;
let snapshot = { y: 0, direction: "up" };

const readScroll = () => {
  frameId = 0;
  const y = Math.max(0, window.scrollY);
  const nextDirection = y > previousY ? "down" : "up";

  if (Math.abs(y - snapshot.y) >= 8 || (y === 0 && snapshot.y !== 0)) {
    snapshot = { y, direction: nextDirection };
    listeners.forEach((listener) => listener());
  }

  previousY = y;
};

const onScroll = () => {
  if (!frameId) frameId = window.requestAnimationFrame(readScroll);
};

const subscribe = (listener) => {
  listeners.add(listener);

  if (!listening) {
    previousY = window.scrollY;
    snapshot = { y: previousY, direction: "up" };
    window.addEventListener("scroll", onScroll, { passive: true });
    listening = true;
  }

  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && listening) {
      window.removeEventListener("scroll", onScroll);
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = 0;
      listening = false;
    }
  };
};

const getSnapshot = () => snapshot;
const serverSnapshot = { y: 0, direction: "up" };
const getServerSnapshot = () => serverSnapshot;

export const useWindowScroll = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
